import {computed, Ref} from 'vue';
import {PulseTimeAllocation} from '../types/DataTypes.ts';
import {useTimeAllocationColors} from './useTimeAllocationColors';
import {isDark} from './useDark.js';

export function useAllocationBar(
  localAllocation: Ref<PulseTimeAllocation>,
  enabledCategories: Ref<any[]>
) {
  const { getCategoryColor } = useTimeAllocationColors();

  // Compute segments for the bar visualization
  const barSegments = computed(() => {
    const segments = enabledCategories.value.map((category, index) => {
      const value = localAllocation.value[category.key as keyof PulseTimeAllocation] || 0;
      const leftPosition = enabledCategories.value.slice(0, index).reduce((sum, cat) => 
        sum + (localAllocation.value[cat.key as keyof PulseTimeAllocation] || 0), 0
      );
      
      return {
        category,
        value,
        leftPosition,
        width: value,
        color: getCategoryColor(category.key),
        canDragLeft: index > 0,
        canDragRight: index < enabledCategories.value.length - 1
      };
    });

    // Calculate no data time
    const allocatedTotal = segments.reduce((sum, segment) => sum + segment.value, 0);
    const unallocated = 100 - allocatedTotal;

    // Add no data segment if there's unallocated time
    if (unallocated > 0) {
      segments.push({
        category: {
          key: 'unallocated',
          label: 'No data',
          description: 'Time not allocated to any category'
        },
        value: unallocated,
        leftPosition: allocatedTotal,
        width: unallocated,
        color: isDark() ? '#374151' : '#F3F4F6', // Dark mode: gray-700, Light mode: gray-100
        canDragLeft: false,
        canDragRight: false
      });
    }

    return segments;
  });

  return {
    barSegments
  };
}
